import { useEffect, useState } from "react";
import { TabButtons } from "../detail";
import { WatchListMenu } from "../data";
import "../index.css";
import { DummyCard } from "../trading/index";
import { demoStockListing } from "../../../services/demoaccount";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

export const WatchList = () => {
  const [selectedTab, setSelectedTab] = useState("");
  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await demoStockListing();
        setStocks(data?.data); // assuming data is an array of stock objects
      } catch (error) {
        console.error("Error fetching stock listing:", error);
      }
    })();
  }, []);

  return (
    <>
      <div>
        <TabButtons
          tabs={WatchListMenu}
          defaultTab={`${WatchListMenu[0]}`}
          onTabChange={(tab) => setSelectedTab(tab)}
        />

        {(selectedTab === "Custom" || selectedTab === "Sector") && (
          <div className="dummy-acc-details-dropdown-wrapper">
            <select className="dummy-profile-dropdown">
              <option>Option 1</option>
              <option>Option 2</option>
            </select>
          </div>
        )}

        <div className="market-grid">
          {stocks?.map((stock, index) => (
            <NavLink
              to={`/trading-details/${stock.SYMBOL}`}
              className="no-link-style"
              key={index}
            >
              <DummyCard
                symbol={stock.SYMBOL}
                price={stock.PRICE}
                change={stock.CHANGE}
                volume={stock.VOLUME}
                color={stock.COLOR}
              />
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
};
